import React from "react";
import { Link } from "react-router-dom";

const QuickLinks = () => (
   <div className="content-card full-width">
      <div className="card-header">
         <h3 className="card-title">
            <i className="bi bi-lightning"></i>
            Quick Access
         </h3>
      </div>
      <div className="quick-links-grid">
         <Link to="/forms" className="quick-link">
            <i className="bi bi-file-text"></i>
            <div className="quick-link-text">
               <span className="quick-link-title">View All Forms</span>
               <span className="quick-link-desc">Browse all submitted forms</span>
            </div>
         </Link>
         <Link
            to={`/driver-form?frontConversation=${Math.random().toString(36).substr(2, 9)}`}
            className="quick-link"
         >
            <i className="bi bi-person-badge"></i>
            <div className="quick-link-text">
               <span className="quick-link-title">Driver Verification</span>
               <span className="quick-link-desc">Create new driver verification</span>
            </div>
         </Link>
         <Link
            to={`/dispatch-form?frontConversation=${Math.random().toString(36).substr(2, 9)}`}
            className="quick-link"
         >
            <i className="bi bi-truck"></i>
            <div className="quick-link-text">
               <span className="quick-link-title">Dispatch Form</span>
               <span className="quick-link-desc">Create new dispatch form</span>
            </div>
         </Link>
         <Link to="/forms?error_status=with_errors" className="quick-link">
            <i className="bi bi-exclamation-triangle"></i>
            <div className="quick-link-text">
               <span className="quick-link-title">Error Reports</span>
               <span className="quick-link-desc">View all error reports</span>
            </div>
         </Link>
      </div>
   </div>
);

export default QuickLinks;
